'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = generateNodeJSExample;
/**
 * Generates a NodeJS example
 * @param {object} req - An adapted request object
 * @param {string} comment - A comment for the code
 * @return {string} A code fragment.
 * @private
 */
function generateNodeJSExample(req, comment) {
	var reqHeaders = [];
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = req.headers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _ref = _step.value;

			var _ref2 = _slicedToArray(_ref, 2);

			var name = _ref2[0];
			var value = _ref2[1];

			reqHeaders.push('\t\t\'' + name + '\': \'' + value + '\'');
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	var headers = reqHeaders.length ? '\n\theaders: {\n' + reqHeaders.join(',\n') + '\n\t},' : '';

	var json = req.acceptJSON ? ',\n\tjson: true' : '';
	var fsModule = '';
	var body = '';
	var form = '';
	switch (req.bodyType) {
		case 'string':
			body = '\n\tbody: \'' + req.body + '\',';
			break;
		case 'json':
			body = '\n\tbody: ' + JSON.stringify(req.body) + ',';
			break;
		case 'form':
			var formData = [];
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = req.body[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _ref3 = _step2.value;

					var _ref4 = _slicedToArray(_ref3, 2);

					var _name = _ref4[0];
					var _value = _ref4[1];

					if (_value instanceof window.File) {
						if (_value.type) {
							formData.push('\t\t\'' + _name + '\': { value: fs.createReadStream(\'' + _value.name + '\'), options: { contentType: \'' + _value.type + '\' } }');
						} else {
							formData.push('\t\t\'' + _name + '\': fs.createReadStream(\'' + _value.name + '\')');
						}
						fsModule = '\nconst fs = require(\'fs\');';
					} else {
						formData.push('\t\t\'' + _name + '\': ' + JSON.stringify(_value));
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			form = '\n\tformData: {\n' + formData.join(',\n') + '\n\t},';
			break;
		case 'file':
			var fileData = 'fs.createReadStream(\'' + req.body.name + '\')';
			fsModule = '\nconst fs = require(\'fs\');';
			body = '\n\tbody: ' + fileData + ',';
			break;
	}

	return '// ' + comment + '\nconst request = require(\'request\');' + fsModule + '\nconst options = {\n\turl: \'' + req.url + '\',\n\tmethod: \'' + req.method + '\',' + headers + body + form + '\n\tgzip: true' + json + '\n};\nrequest(options, (err, response, body) => {\n\tconsole.log(\'success:\', body);\n});';
}
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(generateNodeJSExample, 'generateNodeJSExample', 'src/utility/generateNodeJSExample.js');
}();

;